// src/components/Carousel.jsx
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const slides = [
  {
    src: "/img/carousel.jpg",
    title: "Eventos",
    subtitle: "Actividades culturales y encuentros comunitarios",
    link: "/eventos",
  },
  {
    src: "img/carousel2.jpg",
    title: "Cultura en la casa",
    subtitle: "Propuestas para disfrutar desde tu hogar",
    link: "/cultura",
  },
  {
    src: "img/carousel3.jpg",
    title: "Recomendaciones",
    subtitle: "Te contamos sobre la cultura de la ciudad y la región",
    link: "/recomendaciones",
  },
];

const Carousel = () => {
  const [current, setCurrent] = useState(0);

  const nextSlide = () => {
    setCurrent((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrent((prev) => (prev - 1 + slides.length) % slides.length);
  };

  useEffect(() => {
    const interval = setInterval(nextSlide, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="carousel">
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`carousel-slide ${index === current ? "active" : ""}`}
        >
          <img src={slide.src} alt={slide.title} className="carousel-image" />
          <div className="carousel-overlay">
            <h2>{slide.title}</h2>
            <p>{slide.subtitle}</p>
            <Link to={slide.link} className="carousel-link">VER MÁS</Link>
          </div>
        </div>
      ))}
      <button className="carousel-button left" onClick={prevSlide}>&#10094;</button>
      <button className="carousel-button right" onClick={nextSlide}>&#10095;</button>
    </div>
  );
};

export default Carousel;